import React, {Component} from 'react';
import { Col, Row,Button, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
 import Select   from 'react-select'
 import {
    ADD_SELECTED_CONTRACTORS,CLEAR_SELECTED_CONTRACTORS
} from "actions/actionTypes";
import config from  '../../../config';

export default class AdminContractorSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        var selectedMarkets = _.isUndefined(this.props.location.query.Markets) ? [] : _.map(this.props.location.query.Markets.split(','), function (item) {
            var location = _.find(config.warehouseData, function (o) {
                return o.MarketName == item
            });
            if (location) {
                return {'value': item, 'label': location.MarketName}
            }
        })
        this.state = {
             filterOptions: {
                  perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                 searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                  Types:  _.isUndefined(this.props.location.query.Types) ? [  ] : _.isArray(this.props.location.query.Types) ? _.map(this.props.location.query.Types, function (value) {
                     return _.find([{value:'Contractor', label:'Contractor',} ,{value:'Employee', label:'Employee',}], {value:value})
                 }) : [_.find([{value:'Contractor', label:'Contractor',} ,{value:'Employee', label:'Employee',}], {value:this.props.location.query.Types})],
                 Markets:selectedMarkets
             }
        };

    };
    onCreateTimeChange(option, createTimeOptionName) {

        var optionDisplay = '';
        if (option !== '') {
            optionDisplay = option.format("MM-DD-YYYY");
          //  option = option.utc().format();

        }
        var updateOptions = {...this.state.filterOptions, [createTimeOptionName]: option, createTime: option};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }
    onMarketsSelect(options) {
        var updateOptions = {...this.state.filterOptions, Markets: options};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }
    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    getSearchParams(filtersChanged = {} ) {

        var filterOptions = {...this.state.filterOptions, ...filtersChanged};

      var  queryParams = {};

        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        // if (filterOptions.fromCreateTimeDisplay !== '') {
        //     queryParams.from = filterOptions.fromCreateTimeDisplay.toISOString()
        // }
        //
        // if (filterOptions.toCreateTimeDisplay !== '') {
        //     queryParams.to = filterOptions.toCreateTimeDisplay.toISOString()
        // }
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (_.size(filterOptions.Types) > 0) {
            queryParams.Types = _.map(filterOptions.Types, 'value').join(',')
        }
        if (_.size(filterOptions.Markets) > 0) {
            queryParams.Markets = _.map(filterOptions.Markets, 'value').join(',')
        }
      return {queryParams}
    }
    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }
    onsearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }

    onSelectAllRecordsChange() {
         var self = this;
        if (!this.props.selectAllRecords) {

            this.props.search( {include: ['_id'], all: true}).then(response => {
                this.props.toggleAllRecordsSelection(true)
                console.log('recordIds', response.data);

                self.props.dispatchAction(response.data.data, ADD_SELECTED_CONTRACTORS)
            });
        } else {
            this.props.toggleAllRecordsSelection(false);

            this.props.dispatchAction({}, CLEAR_SELECTED_CONTRACTORS)
        }
    }
    render() {
        var self = this;


         return (
            <div className="contractor-search-block bot15">
                <Row className="">
                    <Col md={3} xs={3} className="top10">
                        <Button className="btn btn-primary" onClick = {this.onSelectAllRecordsChange.bind(this)} >
                            {this.props.selectAllRecords ? 'Clear selection' : 'Select all' }
                        </Button>
                    </Col>
                    <Col md={3} xs={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>
                </Row>
                <Row className="show-grid">

                    <Col md={3} xs={3} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                      onChange={this.onsearchTextChange.bind(this)}
                                     placeholder="Search text"/>
                    </Col>
                    <Col xs={9}  sm={4}  md={4} lg={3}   className="top10">

                        <Select
                            tabIndex="0"
                            multi
                            placeholder="Type"
                            clearable={true}
                            options={ [{value:'Contractor', label:'Contractor',} ,{value:'Employee', label:'Employee',} ]}

                            onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Types: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.Types}
                        />
                    </Col>
                    <Col xs={3} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            multi
                            clearable={false}
                            placeholder="Location"
                            options={   _.map(config.warehouseData, item => {
                                return {value: item.MarketName, label: item.MarketName}
                            })}
                            onChange={this.onMarketsSelect.bind(this)}
                            value={self.state.filterOptions.Markets}
                        />
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" disabled={this.props.pending} onClick={(event) => self.props.search({ })}
                                type="button">
                            Search
                        </button>
                    </Col>
                </Row>
            </div>
        );
    }
}



